module.exports = __webpack_public_path__ + "static/media/paket3New.e5e94fe9.jpg";